import rruleMixin from '../../../../partials/rrule/rruleMixin'
import {
  addDefaultClientReminders,
  addDefaultStaffReminders,
  addDefaultUnscheduledReminders
} from 'components/app/calendar/partials/mixins/remindersMixin'

export default {
  mixins: [rruleMixin],
  methods: {
    baseAddType (model, item, prefillDate = false) {
      if (model.types.find(i => i.id === item.id)) {
        return
      }

      model.types.push(item)
      if (model.types.length === 1) {
        if (this.company.appointments_color_allocation === 'TYPES') {
          model.color = item.color
        }
      }

      if (!model.title && item.title) {
        model.title = item.title
      }

      if (item.description) {
        if (!model.description) {
          model.description = item.description
        }
        else {
          model.description += '\n\n' + item.description
        }
      }

      if (model.status === 'UNSCHEDULED') {
        model.recurring_status = 'UNSCHEDULED'
      }
      else if (model.types.length === 1) {
        model.recurring_status = item.recurring_status
      }

      // if the type has a rrule, try set it for this appointment
      if (this.can(this.permissions.isSubscribed) && !model.recursion_rule && item.recursion_rule) {
        try {
          model.recursion_rule = {
            value: this.createValidatedRrule(item.recursion_rule.value, model.start_date)
          }
        }
        // do nothing - rrule is invalid
        catch (err) {
          console.log(err)
          model.recursion_rule = null
        }
      }

      if (prefillDate) {
        // Set the end date to the start date + the sum of all time_allocations of type
        model.end_date = this.luxon.fromSQL(model.start_date)
          .plus({
            minutes: model.types.reduce((total, item) => total + item.time_allocation, 0)
          })
          .toSimpleSQL()
      }

      // only apply reminders if this is the only appointment type attached to this appointment
      if (model.types.length === 1) {
        // Attempt to create/handle existing reminders appropriately
        // Especially if they switch from one appointment type to another

        // clients
        for (const client of model.clients) {
          // for each client, add default reminders to match the default set for this appointment type
          // If the type has [] (blank/none), it will do nothing here
          addDefaultClientReminders(model, client)
        }

        // staff reminders
        addDefaultStaffReminders(model)

        // unscheduled reminders
        addDefaultUnscheduledReminders(model)
      }

      // Merge required form template IDs from the type
      if (item.required_form_template_ids && item.required_form_template_ids.length > 0) {
        if (!model.required_form_template_ids) {
          model.required_form_template_ids = []
        }
        if (!model.required_form_templates) {
          model.required_form_templates = []
        }

        for (const formId of item.required_form_template_ids) {
          if (!model.required_form_template_ids.includes(formId)) {
            model.required_form_template_ids.push(formId)
          }
        }

        // Also merge the template objects if available
        if (item.required_form_templates && item.required_form_templates.length > 0) {
          for (const template of item.required_form_templates) {
            if (!model.required_form_templates.find(t => t.id === template.id)) {
              model.required_form_templates.push(template)
            }
          }
        }
      }

      // Merge checklist template IDs from the type
      if (item.checklist_template_ids && item.checklist_template_ids.length > 0) {
        if (!model.checklist_template_ids) {
          model.checklist_template_ids = []
        }
        if (!model.checklist_templates) {
          model.checklist_templates = []
        }

        for (const checklistId of item.checklist_template_ids) {
          if (!model.checklist_template_ids.includes(checklistId)) {
            model.checklist_template_ids.push(checklistId)
          }
        }

        // Also merge the template objects if available
        if (item.checklist_templates && item.checklist_templates.length > 0) {
          for (const template of item.checklist_templates) {
            if (!model.checklist_templates.find(t => t.id === template.id)) {
              model.checklist_templates.push(template)
            }
          }
        }
      }
    },
    baseRemoveType (model, item) {
      // Attempt to remove the partial description for this appointment type
      // if the substr can be found
      if (model.description && item.description) {
        let newDescription = model.description.replace('\n\n' + item.description, '')
        // Check if it can find the string with new line chars.
        // If it fails, then try find the string without the new line chars.
        if (newDescription === model.description) {
          newDescription = model.description.replace(item.description, '')
        }
        model.description = newDescription
      }

      model.types.splice(model.types.indexOf(item), 1)
    }
  }
}
